import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DottedKey } from '../../field-definitions/entities/field-definition.entity';
import { ShAbstractHttpService } from '../../http/services/http.abstract.service';
import { Identifier } from '../entities/metadata/metadata.entity';
import { FieldInheritance, RecordInheritance } from '../entities/record-inheritance.class';

@Injectable({ providedIn: 'root' })
export class RecordInheritanceDataService {
    private readonly http: ShAbstractHttpService = inject(ShAbstractHttpService);

    private getEndpoint(recordId: string) {
        return `v2/records/${recordId}/inheritance`;
    }

    getInheritance(recordId: Identifier): Observable<RecordInheritance> {
        const endpoint: string = this.getEndpoint(recordId);

        return this.http.get<Record<DottedKey, FieldInheritance>>(endpoint, undefined, undefined, true).pipe(
            catchError(error => {
                console.error(`RecordInheritanceDataService:: Failed retrieving inheritance of record ${recordId}`);
                return of({});
            }),
            map(result => new RecordInheritance(result))
        );
    }
}
